module.exports = __webpack_public_path__ + "img/tags-m.74cf2fc1.png";